export function CameraIcon({ size = 80 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 7a3 3 0 0 0-2.5 1.34L21.73 17H10a9.67 9.67 0 0 0-9.67 9.67v36.66A9.67 9.67 0 0 0 10 73h60a9.67 9.67 0 0 0 9.67-9.67V26.67A9.67 9.67 0 0 0 70 17H58.27L52.5 8.34A3 3 0 0 0 50 7zm-4.17 14.66L31.6 13h16.78l5.78 8.66a3 3 0 0 0 2.5 1.34H70a3.67 3.67 0 0 1 3.67 3.67v36.66A3.67 3.67 0 0 1 70 67H10a3.67 3.67 0 0 1-3.67-3.67V26.67A3.67 3.67 0 0 1 10 23h13.33a3 3 0 0 0 2.5-1.34m3.84 21.67a10.33 10.33 0 1 1 20.66 0 10.33 10.33 0 0 1-20.66 0M40 27a16.33 16.33 0 1 0 0 32.67A16.33 16.33 0 0 0 40 27"
        fill="currentColor"
      />
    </svg>
  );
}
